var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "Save",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <g id="svg-fg">
    <path d="M48,21.21q0,12.11,0,24.23A2.4,2.4,0,0,1,45.68,48a4.47,4.47,0,0,1-.53,0Q32,48,18.87,48a2.72,2.72,0,0,1-2.14-.74A2.65,2.65,0,0,1,16,45.34Q16,38.68,16,32V18.72A2.46,2.46,0,0,1,18.68,16c8,0,16.07,0,24.1,0a1.4,1.4,0,0,1,1.07.43c1.21,1.23,2.45,2.47,3.68,3.68A1.38,1.38,0,0,1,48,21.21ZM46.34,45.34V21.64a1.1,1.1,0,0,0-.27-.66c-1-1-2-2.05-3.06-3.06a.71.71,0,0,0-.45-.25c-.62,0-1.25,0-2,0v7.25a2.39,2.39,0,0,1-2.49,2.55q-6.1.06-12.25,0a2.4,2.4,0,0,1-2.49-2.55V17.66H19c-1.11,0-1.29.16-1.29,1.27V45.07c0,.18-.06.43,0,.58s.41.64.62.64c1.13.08,2.26,0,3.45,0V36.09c0-1,.23-1.21,1.21-1.21q9,0,18.1,0c1,0,1.19.23,1.19,1.21V46.3l.31,0h2.82C46.08,46.34,46.34,46.05,46.34,45.34Zm-5.75,1V36.54H23.43V46.3ZM39,24.81V17.68h-4v8.16H38C38.7,25.83,39,25.55,39,24.81Zm-5.77,1V17.68h-8.1a1.18,1.18,0,0,0,0,.21c0,2.36,0,4.73,0,7.09,0,.6.31.86.92.86h6.95A1.41,1.41,0,0,0,33.19,25.79Z"/>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/app/assets/icons/save.svg